"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _Select = _interopRequireDefault(require("@material-ui/core/Select"));

var _MenuItem = _interopRequireDefault(require("@material-ui/core/MenuItem"));

var _reactRedux = require("react-redux");

var _selectors = require("../../../redux/locations/selectors");

var _actions = require("../../../redux/locations/actions");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var RadiusSelect = function RadiusSelect(_ref) {
  var otherProps = _extends({}, _ref);

  var _useSearchSelector = (0, _selectors.useSearchSelector)(),
      searchRadius = _useSearchSelector.searchRadius,
      lastSearch = _useSearchSelector.lastSearch,
      lastSearchQuery = _useSearchSelector.lastSearchQuery,
      filter = _useSearchSelector.filter;

  var dispatch = (0, _reactRedux.useDispatch)();
  return /*#__PURE__*/_react.default.createElement(_Select.default, _extends({
    value: searchRadius,
    onChange: function onChange(event) {
      console.log("lastSearch", lastSearch, lastSearchQuery);

      if (lastSearch) {
        dispatch((0, _actions.searchLocations)(lastSearchQuery, lastSearch.lat, lastSearch.lng, event.target.value, filter));
      }
    }
  }, otherProps), _getDistanceOptions().map(function (option) {
    return /*#__PURE__*/_react.default.createElement(_MenuItem.default, {
      value: option,
      key: option
    }, option + " miles");
  }));
};

function _getDistanceOptions() {
  var ret = [];

  for (var i = 1; i * 5 <= 100; i++) {
    ret.push(i * 5);
  }

  return ret;
}

var _default = RadiusSelect;
exports.default = _default;